const EXPECTED_PLAYBACK_REJECTIONS = ['AbortError', 'NotAllowedError'];

const isExpectedPlaybackRejection = error =>
  EXPECTED_PLAYBACK_REJECTIONS.includes(error?.name);

export const handlePlayPromise = playResult => {
  if (!playResult?.catch) {
    return playResult;
  }

  return playResult.catch(error => {
    if (isExpectedPlaybackRejection(error)) {
      return;
    }

    throw error;
  });
};
